"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2068],{

/***/ 2068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "q": function() { return /* binding */ StyledText; }
/* harmony export */ });
/* unused harmony exports h1, h2, h3, h4, p, h5, h6, P, H5, H6 */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9499);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5319);
/* harmony import */ var _lib_consts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9006);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var h1 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  fontWeight: 700,
  fontSize: '32px'
}, _lib_consts__WEBPACK_IMPORTED_MODULE_2__/* .DEVICE_SCREENS_MAX_STRING.md */ .fD.md, {
  fontSize: '22px'
});
var h2 = {
  fontWeight: 700,
  fontSize: '2rem'
};
var h3 = {
  fontWeight: 700,
  fontSize: '1.25rem'
};
var h4 = {
  fontWeight: 500,
  fontSize: '1rem'
};
var p = {
  fontWeight: 500,
  fontSize: '1rem',
  lineHeight: 1.3
};
var h5 = {
  fontWeight: 500,
  fontSize: '0.875rem'
};
var h6 = {
  fontWeight: 500,
  fontSize: '0.75rem'
};
var H1 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h1",  true ? {
  target: "eh81ka07"
} : 0)(h1,  true ? "" : 0);
var H2 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "eh81ka06"
} : 0)(h2,  true ? "" : 0);
var H3 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h3",  true ? {
  target: "eh81ka05"
} : 0)(h3,  true ? "" : 0);
var H4 = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h4",  true ? {
  target: "eh81ka04"
} : 0)(function (_ref) {
  var _ref$bold = _ref.bold,
      bold = _ref$bold === void 0 ? false : _ref$bold;
  return _objectSpread(_objectSpread({}, h4), bold ? {
    fontWeight: 700
  } : {});
},  true ? "" : 0);
var P = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("p",  true ? {
  target: "eh81ka03"
} : 0)(h4,  true ? "" : 0)));
var H5 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("h5",  true ? {
  target: "eh81ka02"
} : 0)(h5,  true ? "" : 0)));
var H6 = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("h6",  true ? {
  target: "eh81ka01"
} : 0)(h6,  true ? "" : 0)));
var StyledText = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eh81ka00"
} : 0)( true ? {
  name: "15lxyhj",
  styles: "h2{font-family:'Golos';font-size:21px;color:#000;margin:20px 0;font-weight:700;}p:not(:last-child){margin-bottom:40px;}ul{display:block;list-style-type:disc;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0px;margin-inline-end:0px;padding-inline-start:40px;}ul>li{list-style-type:inherit!important;display:list-item;::marker{unicode-bidi:isolate;font-variant-numeric:tabular-nums;text-transform:none;text-indent:0px!important;text-align:start!important;text-align-last:start!important;}}ul ul{display:block;list-style-type:circle;}ul ul ul{list-style-type:square;}ol{display:block;list-style-type:decimal;margin-block-start:1em;margin-block-end:1em;margin-inline-start:0px;margin-inline-end:0px;padding-inline-start:40px;}"
} : 0);

/***/ })

}]);